import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Styles.css";

const features = [
  {
    title: "Packaging Proof",
    description:
      "For extra peace of mind, we provide a video of your item being packaged in our warehouse before it’s shipped.",
    image:
      "https://taggmagazine.com/wp-content/uploads//2020/02/woman-holding-iphone.jpeg",
  },
  {
    title: "Dedicated Customer Support",
    description:
      "Whether you have a question about a product or need assistance with your order, our support team is here to help every step of the way.",
    image:
      "https://maconline.de/media/mageplaza/blog/post/c/a/camera-1869430_1920.jpg",
  },
  {
    title: "Easy Returns",
    description:
      "Changed your mind? No problem. Our hassle-free return policy makes it simple to return items within a few days.",
    image:
      "https://banner2.cleanpng.com/lnd/20240416/hki/transparent-apple-logo-two-hands-holding-black-and-silver-smartphone661f2b75146a28.42063839.webp",
  },
];

const FeaturesSection = () => {
  return (
    <Container className="features-section">
      <h2 className="text-center mb-4">Welcome to Datacom</h2>

      {/* About Us Section */}
      <section
        className="about-us-section text-center"
        style={{ marginBottom: "100px" }}
      >
        <p>
          Datacom is your go-to destination for the latest smartphones and
          accessories at competitive prices. We offer a wide range of devices
          from top brands, ensuring everyone can access cutting-edge technology
          hassle-free. Whether you need flagship models, budget-friendly
          options, or essential accessories, we’ve got you covered. With fast
          shipping, secure payments, and exceptional customer support, we make
          shopping seamless—keeping you connected and ahead of the curve.
        </p>
      </section>

      {/* Features Section */}
      <Row>
        {features.map((feature, index) => (
          <Col md={4} className="feature-box" key={index}>
            <>
              <div className="feature-image">
                <img src={feature.image} alt={feature.title} />
              </div>
              <div className="feature-content">
                <h4>{feature.title}</h4>
                <p>{feature.description}</p>
              </div>
            </>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default FeaturesSection;
